import type { Table } from "@tanstack/react-table";

export function getSortedRowData<T>(table: Table<T>): T[] {
  return table.getRowModel().rows.map((row) => row.original);
}
